/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Button, Typography, Typography2 } from '@coursera/cds-core';

import HelpTipCard from 'bundles/degree-home/components/v3-dpm/HelpTipCard';
import LearnMoreDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/LearnMoreDialog';

import _t from 'i18n!nls/degree-home';

const styles = {
  margin: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(8)};
  `,
  button: (theme: Theme) => css`
    margin-top: auto;
    padding-top: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
  `,
};

interface HelpTipCardWithDialogProps {
  title: string;
  tip: string;
  dialogTitle: string;
  dialogMessage: React.ReactNode;
}

const HelpTipCardWithDialog: React.VFC<HelpTipCardWithDialogProps> = ({ title, tip, dialogTitle, dialogMessage }) => {
  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  return (
    <React.Fragment>
      <HelpTipCard>
        <Typography css={styles.margin} variant="h2semibold" component="h3">
          {title}
        </Typography>
        <Typography2 component="p">{tip}</Typography2>
        <Button css={styles.button} edgeAlign="start" type="button" size="medium" variant="ghost" onClick={openDialog}>
          {_t('Learn more')}
        </Button>
      </HelpTipCard>
      <LearnMoreDialog isOpen={isDialogOpen} onClose={closeDialog} title={dialogTitle} message={dialogMessage} />
    </React.Fragment>
  );
};

export default HelpTipCardWithDialog;
